import { getContentByRef } from './get-content-by-ref.js';

const getProductCategories = (productCategoriesCompound, pageModel)=>{
    return productCategoriesCompound === null || productCategoriesCompound === void 0 ? void 0 : productCategoriesCompound.map(({ categoryTitle , description , imageLink , link , key  })=>{
        var ref, ref1, ref2;
        const imageRef = (imageLink === null || imageLink === void 0 ? void 0 : imageLink.$ref) || undefined;
        const imageObject = getContentByRef(imageRef, pageModel);
        return {
            title: categoryTitle,
            description,
            image: {
                url: (imageObject === null || imageObject === void 0 ? void 0 : (ref = imageObject.original) === null || ref === void 0 ? void 0 : (ref1 = ref._links) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.site) === null || ref2 === void 0 ? void 0 : ref2.href) || '',
                description: (imageObject === null || imageObject === void 0 ? void 0 : imageObject.description) || null
            },
            key,
            link: link === null || link === void 0 ? void 0 : link.url
        };
    });
};

export { getProductCategories };
//# sourceMappingURL=get-product-categories.js.map
